import { ZoneCommissionEnum } from '../distribution/enums/zone-commission-enum.model';
import { ICountry } from './country.model';

export interface IDestination {
  id?: number;
  name?: string;
  isStartDestination?: boolean;
  countries?: ICountry[];
  zone?: ZoneCommissionEnum;
  pictureUrl?: string;
  externalCodes?: string[];
  /** @deprecated not present in trip geo model */
  companyId?: string;
  /** @deprecated not present in trip geo model */
  removable?: boolean;
}

export class Destination implements IDestination {
  countries!: ICountry[];
  id!: number;
  isStartDestination!: boolean;
  name!: string;
  zone!: ZoneCommissionEnum;
  pictureUrl!: string;
  externalCodes?: string[];
  /** @deprecated not present in trip geo model */
  companyId?: string;
  /** @deprecated not present in trip geo model */
  removable?: boolean;
}
